'use strict';
import $ from 'jquery';
import helper from './helper';
import auctionHelper from './auction-helper';
import webSocketHelper from './web-socket-helper';
import Cookies from 'js-cookie';

var auctionLifts = {
  _auctions: $('.auction-lift'),

  /**
   * Update bid view
   *
   * @param {object} data Auction status data
   */
  updateBidView: function(data) {
    if (typeof data !== 'undefined' && data !== null && typeof data.auction !== 'undefined') {
      const $auction = $('[data-auction-id="' + data.auction + '"]');

      if ($auction.length === 0) {
        return;
      }

      if (typeof data.endTime !== 'undefined') {
        this._endTime = data.endTime;
        helper.updateTimeLeft(data.auction, data.endTime);
      }

      if (typeof data.priceNow !== 'undefined') {
        $('.auction-price-now-' + data.auction).each(function() { //Each because there can be multiple same auction on one page
          $(this).text(helper.formatPrice(data.priceNow) + ' €');
        });
      }

      if(typeof data.priceMonthly !== 'undefined' && data.priceMonthly) {
        $('.auction-price-monthly-' + data.auction).each(function() {
          $(this).text(helper.formatPrice(data.priceMonthly));
        });
      }

      if(typeof data.bidAmount !== 'undefined') {
        $('.auction-bids-amount-' + data.auction).each(function() {
          $(this).text(data.bidAmount);
        });
      }

      if(typeof data.reservePriceReached !== 'undefined' && data.reservePriceReached === true) {
        // Show reserve price
        $('.auction-reserve-price-reached-' + data.auction).each(function() {
          $(this).removeClass('d-none');
        });
      }

      // Create statuses, status depends on which person is viewing the list.
      auctionHelper.updateAuctionStatusLabels(data);

    }
  },

  /**
   * Handle message that came through web socket
   *
   * @param {object} response The data that came from the web socket
   */
  _handleWebSocketMessage: function(response) {
    try {
      const data = JSON.parse(response.data);
      this.updateBidView(data);
    } catch (e) {
      // Error. ¯\_(ツ)_/¯
    }
  },

  /**
   * Get initial status of auctions
   */
  _getStatuses: function() {
    const self = this;

    const params = {
      'stage-language': window.lang,
      auction: auctionHelper._getVisibleAuctionIDs()
    };

    $.get('/stage-ajax/getAuctionStatus', params, function(data) {
      if (typeof data === 'object' && typeof data.auctions === 'object') {
        data.auctions.forEach(function(auction){
          self.updateBidView({
            auction: auction.id,
            priceNow: auction.priceNow,
            priceMonthly: auction.priceMonthly,
            endTime: auction.endTime,
            startTime: auction.startTime,
            bidAmount: auction.bidAmount,
            leader: auction.leader,
            owner: auction.owner,
            bids: auction.bids,
            allBidders: auction.allBidders,
            reservePriceReached: auction.reservePriceReached
          });
        });
      }
    });
  },

  init: function() {
    if (this._auctions.length > 0) {
      this._getStatuses();
      webSocketHelper.subscribe(auctionHelper._getVisibleAuctionIDs());
      webSocketHelper.addMessageHandler(this.updateBidView.bind(this));
    }

    //Save auction list to cookie on page load
    //This will be used to generate prev/next links on auction page
    if(window.cookieHonkCarAuctionsList) {
      Cookies.set('honk-car-auctions-list', window.cookieHonkCarAuctionsList);
    }
  }
};

module.exports = auctionLifts;
